import type { ModelDefinition } from "@/models.js";

export const nvidiaModels = [
	{
		id: "nemotron-3-ultra-550b",
		name: "Nemotron 3 Ultra 550B",
		description:
			"NVIDIA's most capable model with 550B parameters for complex reasoning, coding, and multimodal tasks.",
		family: "nvidia",
		releasedAt: new Date("2026-06-01"),
		providers: [
			{
				providerId: "deepinfra",
				externalId: "nvidia/NVIDIA-Nemotron-3-Ultra-550B-A55B",
				inputPrice: "0.5e-6",
				outputPrice: "2.5e-6",
				cachedInputPrice: "0.15e-6",
				requestPrice: "0",
				contextSize: 262144,
				maxOutput: undefined,
				quantization: "fp4",
				streaming: true,
				vision: true,
				tools: true,
				jsonOutput: true,
				healStreamingJsonOutput: true,
			},
			{
				providerId: "nebius",
				externalId: "nvidia/Nemotron-3-Ultra-550b-a55b",
				inputPrice: "1.0e-6",
				outputPrice: "3.0e-6",
				requestPrice: "0",
				contextSize: 1048576,
				maxOutput: undefined,
				quantization: "fp4",
				streaming: true,
				reasoning: true,
				vision: false,
				tools: true,
				jsonOutput: true,
			},
		],
	},
	{
		id: "nemotron-3-super-120b",
		name: "Nemotron 3 Super 120B",
		description:
			"NVIDIA's mid-size Nemotron 3 MoE model with 120B total and 12B active parameters, built for efficient reasoning and multi-agent applications.",
		family: "nvidia",
		releasedAt: new Date("2026-03-11"),
		providers: [
			{
				providerId: "nebius",
				externalId: "nvidia/nemotron-3-super-120b-a12b",
				// The deployment rejects tool_choice="required" with a 400, but
				// named function choices work (verified 2026-07-22).
				supportedToolChoices: ["auto", "none", "function"],
				inputPrice: "0.3e-6",
				outputPrice: "0.9e-6",
				requestPrice: "0",
				contextSize: 262144,
				maxOutput: undefined,
				quantization: "fp4",
				streaming: true,
				reasoning: true,
				vision: false,
				tools: true,
				jsonOutput: true,
			},
		],
	},
	{
		id: "nemotron-3-nano-30b",
		name: "Nemotron 3 Nano 30B",
		description:
			"NVIDIA's compact Nemotron 3 MoE model with 30B total and 3B active parameters, offering toggleable reasoning and long context at low cost.",
		family: "nvidia",
		releasedAt: new Date("2025-12-15"),
		providers: [
			{
				providerId: "nebius",
				externalId: "nvidia/NVIDIA-Nemotron-3-Nano-30B-A3B",
				inputPrice: "0.06e-6",
				outputPrice: "0.24e-6",
				requestPrice: "0",
				contextSize: 262144,
				maxOutput: undefined,
				quantization: "fp8",
				streaming: true,
				reasoning: true,
				vision: false,
				tools: true,
				jsonOutput: false,
			},
		],
	},
	{
		id: "nemotron-3-nano-omni",
		name: "Nemotron 3 Nano Omni",
		description:
			"NVIDIA's omni-modal Nemotron 3 Nano model unifying vision, audio, and language understanding for efficient AI agents.",
		family: "nvidia",
		releasedAt: new Date("2026-04-28"),
		providers: [
			{
				providerId: "nebius",
				externalId: "nvidia/Nemotron-3-Nano-Omni",
				inputPrice: "0.06e-6",
				outputPrice: "0.24e-6",
				requestPrice: "0",
				contextSize: 262144,
				maxOutput: undefined,
				quantization: "fp8",
				streaming: true,
				reasoning: true,
				vision: true,
				tools: true,
				jsonOutput: true,
			},
		],
	},
	{
		id: "cosmos3-super-reasoner",
		name: "Cosmos 3 Super Reasoner",
		description:
			"NVIDIA's Cosmos 3 vision-language reasoning model for physical AI, built for understanding real-world environments and multi-step reasoning over visual input.",
		family: "nvidia",
		releasedAt: new Date("2026-06-01"),
		providers: [
			{
				providerId: "nebius",
				externalId: "nvidia/Cosmos3-Super-Reasoner",
				inputPrice: "0.1e-6",
				outputPrice: "0.3e-6",
				requestPrice: "0",
				contextSize: 262144,
				maxOutput: undefined,
				quantization: "fp16",
				streaming: true,
				reasoning: true,
				// The deployment answers inline and never returns
				// reasoning_content (verified 2026-07-22).
				reasoningOutput: "omit",
				vision: true,
				tools: true,
				jsonOutput: true,
			},
		],
	},
] as const satisfies ModelDefinition[];
